import type { AxiosResponse } from 'axios'

import isObject from 'lodash-es/isObject'
import isString from 'lodash-es/isString'

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

/**
 * @description: Format request parameter time
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export function formatRequestDate(params: Recordable) {
  if (Object.prototype.toString.call(params) !== '[object Object]') {
    return
  }

  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in params) {
    const format = params[key]?.format ?? null
    if (format && typeof format === 'function') {
      params[key] = params[key].format(DATE_TIME_FORMAT)
    }
    if (isString(key)) {
      const value = params[key]
      if (value) {
        try {
          params[key] = isString(value) ? value.trim() : value
        } catch (error: any) {
          throw new Error(error)
        }
      }
    }
    if (isObject(params[key])) {
      formatRequestDate(params[key])
    }
  }
}

/**
 * Check user account is expired or not authenticated.
 * @param response
 */
export function checkAccountExpired(response?: AxiosResponse) {
  return (
    response?.data?.errors?.length &&
    response?.data?.errors[0]?.code === 'not_authenticated'
  )
}
